import React, { useEffect, useState } from "react";
import {
  Table,
  Divider,
  PageHeader,
  Button,
  Form,
  Select,
  Input,
  message,
  Modal,
  Segmented,
  Radio,
  Checkbox,
  DatePicker,
  Image,
} from "antd";
import {
  FlexRowContainer,
  FlexRowEndContainer,
  FlexRowQuarterContainer,
  FlexRowReverseContainer,
} from "../Common/Container.styles";

import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";

import * as paymentAPI from "../../api/payment";
import * as orderAPI from "../../api/order";

import {
  dateToCompactString,
  dateToString, getCode,
  numberWithCommas,
} from "../../util/common";

import Pagination from "react-js-pagination";
import { Option } from "antd/lib/mentions";
import { useRecoilState } from "recoil";
import { searchItemState } from "../../states/atoms";
import TextArea from "antd/lib/input/TextArea";
import {getCertificates} from "../../api/user";

export default function PaymentList() {
  const [searchItem, setSearchItem] = useRecoilState(searchItemState);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);

  const [current, setCurrent] = useState(
    Number(sessionStorage.getItem("page")) ?? 1
  );
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState("전체");

  const [startCreatedDate, setStartCreatedDate] = useState(null);
  const [endCreatedDate, setEndCreatedDate] = useState(null);

  const [showRefundModal, setShowRefundModal] = useState(false);

  const onChange = (page) => {
    setCurrent(page);
    sessionStorage.setItem("page", page);
  };

  const [form] = Form.useForm();

  const searchQuery = Form.useWatch("searchQuery", form);
  const searchKeyword = Form.useWatch("searchKeyword", form);
  const status = Form.useWatch("status", form);
  const bannering = Form.useWatch("bannering", form);
  const size = Form.useWatch("size", form);

  const fetchItems = () => {
    const request = {
      page: current,
      size: size ?? 50,
      startCreatedDate,
      endCreatedDate,
    };
    request[`${searchQuery}`] = searchKeyword;
    request[`${searchItem.searchQuery}`] = searchItem.searchKeyword;

    paymentAPI.getPayments(request).then((res) => {
      if (res.data.linusCode === 1) {
        setTotal(res.data.page.count);
        setItems(res.data.data?.map((item) => {return {...item, key: item?.id}}))
        setLoading(false);
      } else {
        alert(res.data.data.msg);
      }
    });
  };

  useEffect(() => {
    if (current !== 1) {
      setCurrent(1);
      return;
    }

    setLoading(true);
    fetchItems();
  }, [filter, startCreatedDate, endCreatedDate, status, bannering, size, searchItem]);

  useEffect(() => {
    setLoading(true);
    fetchItems();
  }, [current]);

  const onSearch = (e) => {
    if (!searchQuery) {
      message.error("검색조건을 선택해주세요.");
      return;
    }

    if (!searchKeyword) {
      message.error("검색 키워드를 입력해주세요.");
      return;
    }

    const newSearchItem = {
      ...searchItem,
      searchQuery: searchQuery,
      searchKeyword: searchKeyword,
    };
    setSearchItem(newSearchItem);

    setCurrent(1);
    sessionStorage.setItem("page", 1);

    setLoading(true);
    // fetchItems();
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedItems(selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === "Disabled Banner",
      // Column configuration not to be checked
      name: record.name,
    }),
  };

  // 주문번호, 닉네임, 가입채널, 가입년월일시, 최종로그인년월일시, 마케팅동의여부
  const columns = [
    { title: "ID", dataIndex: "id" },
    {
      title: "구매한 유저 이름/이메일",
      dataIndex: "user",
      render: (val, obj) => {
        return (
          <div onClick={() => navigate(`/user/user/edit/${val?.id}`)}>{val?.name}<br></br>{val?.email}</div>
        )
      },
    },
    {
      title: "금액",
      dataIndex: "price",
      render: (val) => {
        return numberWithCommas(val) + '원'
      },
    },
    {
      title: "지불수단",
      dataIndex: "type",
    },
    {
      title: "결제상태",
      render: (val) => {
        return val?.order?.status ?? '-'
      },
    },
    {
      title: "주문상품",
      dataIndex: "order",
      render: (val) => {
        return (
          val?.orderProducts?.map((item, index) => {
            return (
              <div>
                [{item?.product?.group}]{item?.product?.name} x {item?.quantity}개
              </div>
            )
          })
        )
      },
    },
    {
      title: "결제시각",
      dataIndex: "createdDate",
      width: "10%",
      render: (val) => {
        return dateToString(val);
      },
    },
    {
      title: "환불처리",
      dataIndex: "isUsedMoreOnce",
      width: "10%",
      render: (val, obj) => {
        return (
          (!val && obj?.order?.status !== '환불완료') &&
            <Button
              danger
              onClick={() => {
                if (window.confirm('해당 주문을 환불 처리 하시겠습니까?')) {
                  orderAPI.editOrder({
                    id: obj?.order?.id,
                    status: '환불완료'
                  }).then(res => {
                    if (res.data.linusCode === 1) {
                      message.success('환불처리 되었습니다.')
                      fetchItems()
                    }
                  })
                }

              }}
            >
              환불처리
            </Button>
        )
      },
    },


  ];

  const searchQueries = [
    {
      title: "유저 이름",
      dataIndex: "userName",
    },
    {
      title: "유저 이메일",
      dataIndex: "userEmail",
    },
    {
      title: "금액",
      dataIndex: "price",
    },
    {
      title: "지불수단",
      dataIndex: "type",
    },
    {
      title: "결제상태",
      dataIndex: "status",
    },
    {
      title: "주문상품",
      dataIndex: "product",
    },
    {
      title: "결제시각",
      dataIndex: "createdDate",
    },
  ];

  return (
    <div>
      <PageHeader
        className="site-page-header"
        title="결제 목록"
        subTitle={`총 ${total}개의 결제가 존재합니다.`}
      />
      <Form form={form} onFinish={onSearch}>
        <FlexRowContainer style={{ marginTop: "10px" }}>
          <FlexRowQuarterContainer>
            <Form.Item name="searchQuery" initialValue={searchItem.searchQuery}>
              <Select placeholder="검색조건" style={{width: 100}}>
                {searchQueries?.map((c) => {
                  return (
                    <Select.Option key={c.dataIndex} value={c.dataIndex}>
                      {c.title}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="searchKeyword"
              initialValue={searchItem.searchKeyword}
            >
              <Input placeholder="검색 키워드를 입력하세요" />
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              />
            </Form.Item>
          </FlexRowQuarterContainer>
        </FlexRowContainer>
        <FlexRowContainer style={{ marginTop: "30px" }}>
          <Button
            type="primary"
            onClick={(e) => {
              e.preventDefault();
              const newSearchItem = {
                ...searchItem,
                searchQuery: null,
                searchKeyword: null,
              };
              setSearchItem(newSearchItem);

              setCurrent(1);
              sessionStorage.setItem("page", 1);
              form.setFieldValue("searchQuery", null);
              form.setFieldValue("searchKeyword", null);
            }}
          >
            검색 조건 초기화
          </Button>
        </FlexRowContainer>
      </Form>
      <Divider />
      <Table
        pagination={false}
        loading={loading}
        columns={columns}
        dataSource={items}
        rowSelection={{
          type: "checkbox",
          ...rowSelection,
        }}
        // onRow={(record, rowIndex) => {
        //   return {
        //     onClick: (event) => {
        //       navigate(`/setting/banner/edit/${record.id}/`);
        //     }, // click row
        //     onDoubleClick: (event) => {}, // double click row
        //     onContextMenu: (event) => {}, // right button click row
        //     onMouseEnter: (event) => {}, // mouse enter row
        //     onMouseLeave: (event) => {}, // mouse leave row
        //   };
        // }}
      />
      <FlexRowEndContainer style={{ marginTop: "30px" }}>
        <Pagination
          activePage={current}
          itemsCountPerPage={size ?? 50}
          totalItemsCount={total}
          pageRangeDisplayed={10}
          onChange={onChange}
        />
      </FlexRowEndContainer>
    </div>
  );
}
